/**
 * Popup compacto de busca — desktop
 */
(function () {
  if (customElements.get('search-modal')) return;

  class SearchModal extends HTMLElement {
    constructor() {
      super();
      this.openTriggers = [];
      this._onKeydown = this._onKeydown.bind(this);
    }

    connectedCallback() {
      this.dialog = this.querySelector('.search-modal__dialog');
      this.input = this.querySelector('.search-modal__input');
      this.predictiveSearch = this.querySelector('predictive-search');

      this.querySelectorAll('[data-search-modal-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      document.querySelectorAll('[data-header-search-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          if (window.innerWidth < 1024) return;
          event.preventDefault();
          this.isOpen() ? this.close() : this.open();
        });
        this.openTriggers.push(trigger);
      });
    }

    isOpen() {
      return this.hasAttribute('open');
    }

    open() {
      if (window.innerWidth < 1024) return;

      this.removeAttribute('hidden');
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('search-modal-open');

      this.openTriggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'true');
      });

      document.addEventListener('keydown', this._onKeydown);

      var self = this;
      window.requestAnimationFrame(function () {
        if (self.input) {
          self.input.focus();
          self.input.setAttribute('aria-expanded', 'false');
        }
        self._trapFocus();
      });
    }

    close() {
      this.removeAttribute('open');
      this.setAttribute('hidden', '');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('search-modal-open');

      this.openTriggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      if (this.predictiveSearch && typeof this.predictiveSearch.close === 'function') {
        this.predictiveSearch.close(true);
      }

      document.removeEventListener('keydown', this._onKeydown);

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.openTriggers[0] || null);
      }
    }

    _onKeydown(event) {
      if (event.code === 'Escape') {
        event.preventDefault();
        this.close();
      }
    }

    _trapFocus() {
      if (typeof trapFocus !== 'function' || !this.dialog) return;
      trapFocus(this.dialog, this.input);
    }
  }

  customElements.define('search-modal', SearchModal);
})();
